import Vue from 'vue';
import Router from 'vue-router';
import beforeEnter from '@/utils';

const LoginPage = () => import('@/pages/LoginPage')
const DefaultLayout = () => import('@/layouts/DefaultLayout')
const DashboardPage = () => import('@/pages/dashboard/DashboardPage')
const StatisticPage = () => import('@/pages/dashboard/StatisticPage')
const UsersPage = () => import('@/pages/users/UsersPage')
const UsersAddEditPage = () => import('@/pages/users/UsersAddEditPage')

const NotFoundPage = () => import('@/pages/NotFoundPage.vue')

Vue.use(Router)

export default new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    linkExactActiveClass: 'open active',
    scrollBehavior: () => ({y: 0}),
    routes: [
        {
            path: '/',
            name: 'Home',
            redirect: '/dashboard',
            component: DefaultLayout,
            beforeEnter: beforeEnter,
            children: [
              {
                path: 'dashboard',
                name: 'Dashboard',
                redirect: '/dashboard/list',
                beforeEnter: beforeEnter,
                component: {
                  render(c) {
                    return c('router-view');
                  }
                },
                children: [
                  {
                    path: 'list',
                    name: 'DashboardPage',
                    component: DashboardPage
                  }
                ]
              },
              {
                path: 'statistic',
                name: 'Statistic',
                redirect: '/statistic/list',
                beforeEnter: beforeEnter,
                component: {
                  render(c) {
                    return c('router-view');
                  }
                },
                children: [
                  {
                    path: 'list',
                    name: 'StatisticPage',
                    component: StatisticPage
                  }
                ]
              },
              {
                path: 'users',
                name: 'Users',
                redirect: '/users/list',
                beforeEnter: beforeEnter,
                component: {
                  render(c) {
                    return c('router-view');
                  }
                },
                children: [
                  {
                    path: 'list',
                    name: 'UsersPage',
                    component: UsersPage
                  },
                  {
                    path: 'add',
                    name: 'UsersAdd',
                    component: UsersAddEditPage
                  },
                  {
                    path: 'edit/:id',
                    name: 'UsersEdit',
                    component: UsersAddEditPage
                  }
                ]
              }
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: LoginPage
        },
        {
            path: '/404',
            name: 'NotFound',
            component: NotFoundPage
        },
        {
            path: '*',
            component: NotFoundPage
        }
    ]
})
